import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  content: {
    required,
  },
};

export default validations;